module.exports = __webpack_public_path__ + "static/img/wxtu.3a9c75c0.png";